import {
  CUSTOM_PERSONAL_MESSAGE_MAX_CHARACTERS,
  TEXTFIELD_MAX_CHARACTERS,
} from './constraints'

export const ERROR_CUSTOM_AMOUNT_INVALID =
  'Please enter an amount between ${minAmount} and ${maxAmount}' // {minAmount} and {maxAmount} to be replaced during runtime with values from GraphQL API / eCommerce platform
export const ERROR_AMOUNT_REQUIRED = 'Please select an amount'
export const ERROR_RECIPIENT_NAME = `Please keep recipient name under ${TEXTFIELD_MAX_CHARACTERS} characters`
export const ERROR_RECIPIENT_NAME_REQUIRED = 'Please enter a recipient name'
export const ERROR_RECIPIENT_REQUIRED = 'Please select a recipient'
export const ERROR_FROM_NAME = `Please keep sender name under ${TEXTFIELD_MAX_CHARACTERS} characters`
export const ERROR_FROM_NAME_REQUIRED = 'Please enter your name'
export const ERROR_CUSTOM_PERSONAL_MESSAGE = `Please enter a message of ${CUSTOM_PERSONAL_MESSAGE_MAX_CHARACTERS} characters or less`
export const ERROR_EMAIL_MISSING = 'Please enter a valid email address'
export const ERROR_EMAIL_INVALID = 'Please enter a valid email address'
export const ERROR_MOBILE_NUMBER_MISSING = 'Please enter a mobile number'
export const ERROR_MOBILE_NUMBER_INVALID = 'Mobile number is invalid'
export const ERROR_DELIVERY_DATE_INVALID =
  'Please enter a valid future date in DD/MM/YYYY format'
export const createErrorDeliveryDateValidRangeExceeded = (
  DELIVERY_DATE_MAX_FUTURE_DATE_MONTHS: number
): string =>
  `Please select a delivery date occurring within the next ${DELIVERY_DATE_MAX_FUTURE_DATE_MONTHS} months`
export const ERROR_DELIVERY_METHOD_REQUIRED = 'Please select a delivery method'
export const TERMS_AND_CONDITIONS_REQUIRED =
  'You must accept the Terms & Conditions and the Privacy Statement'
export const createErrorMaximumStringLengthExceeded = (
  MAXIMUM_STRING_LENGTH: number
): string => `Please enter fewer than ${MAXIMUM_STRING_LENGTH} characters`
export const ERROR_UPDATE_DELIVERY_ADDRESS = 'Unable to update delivery address'
export const ERROR_UPDATE_DELIVERY_DEFAULT = 'Unable to update default'
export const ERROR_REMOVE_DELIVERY_ADDRESS = 'Unable to remove delivery address'
export const ERROR_UPDATE_PAYMENT_METHOD =
  'There was a problem updating the payment method. Please try again'
export const ERROR_REMOVE_PAYMENT_METHOD =
  'There was a problem removing the payment method. Please try again'
export const ERROR_UPDATE_DEFAULT_PAYMENT =
  'There was a problem updating the default payment method. Please try again'
export const ERROR_RETRIEVE_USER_DETAILS =
  'Unable to retrieve user details at this time.'
export const ERROR_UPDATE_NAME = 'Unable to update name'
export const ERROR_UPDATE_EMAIL = 'Unable to update email'
export const ERROR_UPDATE_MOBILE = 'Unable to update mobile'
export const ERROR_REMOVE_MOBILE = 'Unable to remove mobile number'
export const ERROR_VERIFY_MOBILE_INVALID =
  'Unable to verify mobile number. Please confirm that the verification code is correct'
export const ERROR_UPDATE_MOBILE_TOO_MANY_ATTEMPTS =
  'Unable to update mobile number. Too many attempts. Please contact support'
export const ERROR_RESEND_CODE_TOO_MANY_ATTEMPTS =
  'Unable to resend code. Too many attempts. Please contact support'
export const ERROR_UPDATE_PREFERENCES =
  'There was a problem updating your preference. Please try again'
export const ERROR_RESEND_CODE_EMAIL_INVALID =
  'Unable to resend code. Email address is invalid'
export const ERROR_RESEND_CODE = 'Unable to resend code'
export const ERROR_RESEND_CODE_COMMS_ERROR =
  'Unable to resend code. Error communicating with provider'
export const ERROR_UNDO_EMAIL_CHANGE = 'Unable to undo email change'
export const ERROR_UPDATE_EMAIL_CONTACT_SUPPORT =
  'Unable to update email. Please try again or contact support'
export const ERROR_UPDATE_EMAIL_TOO_MANY_ATTEMPTS =
  'Unable to update email. Too many failed attempts in a row'
export const ERROR_UPDATE_EMAIL_INVALID_CODE = 'Verification code is not valid'
export const ERROR_UPDATE_EMAIL_CODE_MISMATCH =
  'Verification code did not match'
export const ERROR_RETRIEVE_ORDERS = 'Unable to retrieve orders at this time.'
export const ERROR_RETRIEVE_PROFILE = 'Unable to retrieve profile at this time.'
export const ERROR_UNEXPECTED_OBJECT = 'Unexpected object: '
export const ERROR_GET_INITIAL_PROPS_MISSING_DATA =
  '_error.js getInitialProps missing data at path:'
export const ERROR_UNSUBSCRIBE_WITH_EMAIL =
  'Unable to unsubscribe. Please try again or contact support'
export const ERROR_UNSUBSCRIBE_WITH_PREFERENCES_TOKEN =
  'Unable to unsubscribe automatically'
